import { render, staticRenderFns } from "./dispatch.vue?vue&type=template&id=4dfcf394&"
import script from "./dispatch.vue?vue&type=script&lang=coffee&"
export * from "./dispatch.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports